import {Fragment, useState} from "react";
import {Autocomplete, Checkbox, FormControlLabel, Grid, IconButton, TextField, Tooltip} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {isCohortLimited} from "../abTestFormModel";

/**
 * Настройки одной когорты. Ошибки приходят из validateCohorts (форма), компонент только отображает
 * и сообщает об изменениях: onChange(field, value).
 */
function CohortContent({cohort, errors, userGroups, onChange}) {
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
    const limited = isCohortLimited(cohort);
    const change = (event) => onChange(event.target.name, event.target.value);
    const toggle = (event) => onChange(event.target.name, event.target.checked);

    return <Grid item xs={12}>
        <Grid item xs={12} container spacing={1}>
            <Grid item xs={12}>
                <TextField
                    label={'Cohort Id'}
                    fullWidth
                    name={'id'}
                    value={cohort.id}
                    error={errors.has('idError')}
                    helperText={errors.has('idError') ? 'Give the cohort a unique name (not "Cohort N")' : undefined}
                    onChange={change}
                />
            </Grid>
            <Grid item xs={2}>
                <FormControlLabel
                    control={<Checkbox name='active' checked={!!cohort.active} onChange={toggle}/>}
                    label="Active"
                />
            </Grid>
            <Grid item xs={2}>
                <FormControlLabel
                    control={<Checkbox name='limited' checked={limited} onChange={toggle}/>}
                    label="Limited"
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={'Size Limit'}
                    fullWidth
                    name={'limit'}
                    value={cohort.limit}
                    error={errors.has('limitError')}
                    disabled={!limited}
                    onChange={change}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={'Weight'}
                    fullWidth
                    name={'weight'}
                    value={cohort.weight}
                    error={errors.has('weightError')}
                    onChange={change}
                />
            </Grid>
            <Grid item xs={12}>
                {userGroups && <Autocomplete
                    multiple
                    disableClearable
                    options={userGroups}
                    value={cohort.userGroup || []}
                    onChange={(e, value) => onChange('userGroup', value)}
                    renderInput={(params) => (
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <TextField
                                {...params}
                                id="userGroup"
                                name="userGroup"
                                label="User Group Id"
                                error={errors.has('userGroupError')}
                                helperText={errors.has('userGroupError') ? 'This user group is already used in another cohort' : undefined}
                                style={{flex: 1}}
                            />
                            <Tooltip title="Принудительно распределить игроков из указанных User Group в эту когорту">
                                <IconButton>
                                    <InfoOutlinedIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    )}
                />}
            </Grid>

            <Grid item xs={12} style={{paddingTop: 3}} display={'flex'} justifyContent={'center'}>
                <span style={{textDecoration: 'underline dotted', cursor: 'pointer'}}
                      onClick={() => setShowAdvancedSettings(!showAdvancedSettings)}>
                    advanced settings
                </span>
            </Grid>
            {showAdvancedSettings && <Fragment>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={'Parameters'}
                        minRows={3}
                        multiline
                        name={'parameters'}
                        value={cohort.parameters}
                        error={errors.has('parametersError')}
                        helperText={errors.has('parametersError') ? 'Must be a JSON object' : undefined}
                        onChange={change}
                    />
                </Grid>
            </Fragment>}
        </Grid>
    </Grid>;
}

export default CohortContent;
